// removed by extract-text-webpack-plugin
module.exports = {"PDFTemplate":"PDFTemplate__PDFTemplate___1X1tT","PDFTemplateHeader":"PDFTemplate__PDFTemplateHeader___WJWfn","PDFTemplateFooter":"PDFTemplate__PDFTemplateFooter___27j0x"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/PDFTemplate/PDFTemplate.less
// module id = 1197
// module chunks = 0 1